import { useEffect, useState, type ReactElement } from "react";
import { Icon } from "../Icon/Icon";
import styles from "./SearchInput.module.css";

export interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  prompt?: string;
  count?: string;
  debounceMs?: number;
}

export function SearchInput({
  value,
  onChange,
  placeholder,
  prompt,
  count,
  debounceMs = 150,
}: SearchInputProps): ReactElement {
  const [text, setText] = useState(value);

  useEffect(() => {
    setText(value);
  }, [value]);

  useEffect(() => {
    if (text === value) return;
    const id = setTimeout(() => onChange(text), debounceMs);
    return () => clearTimeout(id);
    // onChange is stable; re-run only when the local text changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, debounceMs]);

  return (
    <div className={styles.wrap}>
      {prompt ? (
        <span className={styles.prompt}>{prompt}</span>
      ) : (
        <Icon name="search" size={18} className={styles.icon} />
      )}
      <input
        className={styles.input}
        type="text"
        value={text}
        placeholder={placeholder}
        onChange={(event) => setText(event.target.value)}
        aria-label={placeholder ?? "Search"}
      />
      {count ? <span className={styles.count}>{count}</span> : null}
    </div>
  );
}
